import React, { useState } from "react";
import "./want-by-modal.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Select_lense_modal from "./Select_lense_modal";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllCart, postCart } from "../../../../features/cart/cartSlice";
import Power_Type_Modal from "../power_type_modal/Power_Type_Modal";

const Want_buy_modal = ({ variant, product, product_id, ...props }) => {
  const [selectlense, setSelectlense] = useState(false);
  const dispatch = useDispatch();
  const isSignIn = useSelector((state) => state.auth.is_signin);
  const addToCart = async () => {
    try {
      const data = {
        product_id: product?.id,
        variant_id: variant?.id,
        quantity: 1,
      };
      const res = await dispatch(postCart({ data: data, isSignIn: isSignIn }));

      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(getAllCart(isSignIn));
      } else if (res.meta?.requestStatus === "rejected") {
        console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };
  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="want_modal"
      >
        <Modal.Body>
          <div className="modal_sec">
            <div className="title_div">
              <h4 className="h4title">Want to Buy</h4>
            </div>
            <div className="btnflex">
              <button
                className="com-btn"
                type="button"
                onClick={() => {
                  props.onHide();
                  setSelectlense(true);
                }}
              >
                With Lens
              </button>
              <p className="ortext">Or</p>
              <Link className="w-100" to="/cart">
                <button className="com-btn" onClick={addToCart}>
                  Only Frame
                </button>
              </Link>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* <Select_lense_modal
        product={product}
        variant={variant}
        product_id={product_id}
        show={selectlense}
        onHide={() => setSelectlense(false)}
      /> */}

      <Power_Type_Modal
        product={product}
        // variant={variant}
        product_id={product_id}
        show={selectlense}
        onHide={() => setSelectlense(false)}
      />
    </>
  );
};

export default Want_buy_modal;
